import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "@progress/kendo-angular-l10n";
import { HelpersService } from "../helpers-service/helpers.service";

@Injectable()
export class KendoMessageService extends MessageService {
    translateService = inject(TranslateService);
    helpersService = inject(HelpersService);

    constructor() {
        super();

        this.translateService.onLangChange.subscribe(() => {
            this.notify(false);
        });
    }

    public get(key: string): string {
        if (this.helpersService.getLang() === "fr-CA") {
            const translated = this.translateService.instant(key);
            if (translated === key) {
                return undefined;
            } else {
                return translated;
            }
        } else {
            return undefined;
        }
    }
}
